import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { isDAProvider } from '@lyrahealth-inc/shared-app-logic/src/features/providers/utils'

import { isEngageDAProvider } from '../../../../common/utils/utils'
import { getAuthUser } from '../../../../data/auth/authSelectors'

// The DA rollout gates the viewer only. Which counterparts are messageable is decided by the
// backend through care-history can_message.
export const useProviderPairMessagingAccess = () => {
  const { isProviderProviderMessagingEnabled, isDAProviderProviderMessagingEnabled } = useFlags()
  const user = useSelector(getAuthUser)
  const isViewerDA =
    isDAProvider({ programTaxonomy: user?.program_taxonomies ?? [] }) || isEngageDAProvider(user?.roles ?? [])
  return {
    canAccessProviderPairs: Boolean(
      isProviderProviderMessagingEnabled && (isDAProviderProviderMessagingEnabled || !isViewerDA),
    ),
  }
}
